export const createEmptyListResponseStructure = () => ({
  data: [],
  total: 0,
  pagination: {
    hasMore: false,
    cursor: null,
  },
});
